layout:
  - type: panel
    kind: row
    id: base-layout
    tag: main
    children:
      - type: panel
        kind: column
        id: content
        tag: section
        style:
          max-width: 65%
        children:
      - type: panel
        kind: column
        id: right-pane
        tag: aside
        style:
          max-width: 35%
        children:
          - type: widget
            kind: simple-list
            preset: siteSocialLinks
          - type: widget
            kind: calendar
            preset: defaultCalendar
          - type: widget
            kind: simple-list
            preset: recentEvents
            title: i18n.widget.recentEvents
  # Profile detail — full-width content, no site right-pane (concept layout)
  - type: panel
    kind: row
    id: profile-detail-layout
    tag: main
    children:
      - type: panel
        kind: column
        id: content
        tag: section
        children:
  # Home — full-width events carousel (no right pane); backup in concept/home/backup-pre-carousel-*
  - type: panel
    kind: row
    id: home-page-layout
    tag: main
    children:
      - type: panel
        kind: column
        id: content
        tag: section
        children:
          - type: widget
            kind: events-carousel
            preset: homeUpcoming
  - type: extension
    id: about-page-layout
    extending: base-layout
    children:
      - type: extension
        extending: content
        children:
          - type: panel
            id: about
            tag: section
            children:
              - type: widget
                kind: static
                tag: h2
                content: i18n.pages.about.title
              - type: widget
                kind: static
                tag: article
                content: i18n.pages.about.text
  - type: extension
    id: articles-list-layout
    extending: base-layout
    children:
      - type: extension
        extending: content
        children:
          - type: widget
            kind: breadcrumb
            tag: h2
          - type: widget
            kind: resource-list
            tag: ul
            preset: articlesList
  - type: extension
    id: articles-details-layout
    extending: base-layout
    children:
      - type: extension
        extending: content
        children:
          - type: widget
            kind: breadcrumb
            tag: h2
          - type: widget
            kind: resource-view
            tag: article
            preset: articleDetails
  - type: panel
    kind: row
    id: events-list-layout
    tag: main
    children:
      - type: panel
        kind: column
        id: left-pane
        tag: aside
        style:
          max-width: 35%
        children:
          - type: widget
            kind: calendar
            preset: defaultCalendar
      - type: panel
        kind: column
        id: content
        style:
          max-width: 65%
        children:
          - type: widget
            kind: horizontal-card-list
            preset: upcomingEvents
            title: i18n.widget.upcomingEvents
          - type: widget
            kind: horizontal-search-form
            preset: eventsSearchForm
            title: i18n.widget.upcomingEvents
          - type: widget
            kind: resource-list
            tag: ul
            preset: eventsList
          
